import { Expose } from 'class-transformer'

export class BookChapterCampaignHeader {
  @Expose() minSellingPrice: number

  @Expose() totalChapter: number

  @Expose() startedAt: string

  @Expose() endedAt: string
}
